/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMoodAnnoyed2 = createReactComponent("mood-annoyed-2", "IconMoodAnnoyed2", [
  ["path", { d: "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z", key: "svg-0" }],
  ["path", { d: "M15 14c-2 0 -3 1 -3.5 2.05", key: "svg-1" }],
  ["path", { d: "M10 9.25c-.5 1 -2.5 1 -3 0", key: "svg-2" }],
  ["path", { d: "M17 9.25c-.5 1 -2.5 1 -3 0", key: "svg-3" }]
]);

export { IconMoodAnnoyed2 as default };
//# sourceMappingURL=IconMoodAnnoyed2.js.map
